import { WeekView } from '@devexpress/dx-react-scheduler-material-ui';
import React from 'react';

import { useIsMobile } from '@hooks/useIsMobile';

const WeekDayCell = ({ ...props }: WeekView.DayScaleCellProps) => {
  const isMobile = useIsMobile();

  return (
    <WeekView.DayScaleCell
      {...props}
      style={{ width: isMobile ? '150px' : 'auto' }}
    />
  );
};

export default WeekDayCell;
